var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6H7.272C8.292 6 9.182 6.686 9.446 7.67L10.212 10.544M10.212 10.544C21.3534 10.2288 32.4844 11.4694 43.284 14.226C41.636 19.132 39.678 23.9 37.436 28.5H15M10.212 10.544L15 28.5M15 28.5C13.4087 28.5 11.8826 29.1321 10.7574 30.2574C9.63214 31.3826 9 32.9087 9 34.5H40.5M12 40.5C12 40.8978 11.842 41.2794 11.5607 41.5607C11.2794 41.842 10.8978 42 10.5 42C10.1022 42 9.72064 41.842 9.43934 41.5607C9.15804 41.2794 9 40.8978 9 40.5C9 40.1022 9.15804 39.7206 9.43934 39.4393C9.72064 39.158 10.1022 39 10.5 39C10.8978 39 11.2794 39.158 11.5607 39.4393C11.842 39.7206 12 40.1022 12 40.5ZM37.5 40.5C37.5 40.8978 37.342 41.2794 37.0607 41.5607C36.7794 41.842 36.3978 42 36 42C35.6022 42 35.2206 41.842 34.9393 41.5607C34.658 41.2794 34.5 40.8978 34.5 40.5C34.5 40.1022 34.658 39.7206 34.9393 39.4393C35.2206 39.158 35.6022 39 36 39C36.3978 39 36.7794 39.158 37.0607 39.4393C37.342 39.7206 37.5 40.1022 37.5 40.5Z",
    stroke: "#79AC78",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.a51f7aa380cff6c7927f4bef8fc5663e.svg";
export { ForwardRef as ReactComponent };